import ApplicationController from '../application-controller';

export default class extends ApplicationController {
  static values = {
    class: String,
  };

  declare classValue: string;
  declare readonly hasClassValue: boolean;

  get isActive() {
    return this.element.classList.contains(this.classValue);
  }

  on() {
    this.element.classList.add(this.classValue);
  }

  off() {
    this.element.classList.remove(this.classValue);
  }

  toggle() {
    if (this.isActive) {
      this.off();
    } else {
      this.on();
    }
  }
}
